import { ref } from 'vue';
import { io } from 'socket.io-client';
import { useIp } from './useIp';
import { useAuthStore } from '@/stores';

let socketRef = null;

export function useSocket() {
  if (!socketRef) {
    const ips = useIp();
    const authStore = useAuthStore();

    const token = authStore.token;

    if (!token) {
      console.warn('WebSocket: No auth token found. Connection might fail authentication.');
    }

    const socket = io(ips.ipWebSocket, {
      transports: ["websocket"],
      upgrade: false,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      randomizationFactor: 0.5,
      auth: {
        token: token
      }
    });

    socket.on('connect_error', (err) => {
      if (err.message === 'Authentication error') {
        console.error("WebSocket Authentication Failed:");
      }
    });

    socketRef = ref(socket);
  }
  
  return { socket: socketRef };
} 